export enum DriverLoadStatusEnum {
    REJECTED = 'Rejected',
    ACCEPTED = 'Accepted',
    PENDING = 'Pending',
    CANCELED = 'Canceled',
}
